import { render, staticRenderFns } from "./MovingFromAddressFormPart.be.vue?vue&type=template&id=450fa352"
import script from "./MovingFromAddressFormPart.be.vue?vue&type=script&lang=js"
export * from "./MovingFromAddressFormPart.be.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports